import { Col, Container, Row } from "react-bootstrap";
import React from "react";
import Desplegable from "../../desplegable";

const extractTableName = cargo => {
    switch (cargo.cargoTableType) {
        case "province":
            return cargo.provincia.name;
        case "community":
            return cargo.comunidad.name;
        case "workgroup":
            return cargo.workgroup?.name;
        case "mission":
            return cargo.mission.name;
        default:
            return "Desconocido";
    }
}

const mapCargo = (cargo) => {
    return (
        <Container>
            <Row>
                <Col lg="6" className="border">
                    <h6>Cargo</h6>
                    <p>{cargo.cargo}</p>
                </Col>

                <Col lg="6" className="border">
                    <h6>En</h6>
                    <p>{extractTableName(cargo)}</p>
                </Col>
            </Row>
            <Row>
                <Col lg="6" className="border">
                    <h6>Fecha de inicio</h6>
                    <p>{cargo.startDate}</p>
                </Col>

                <Col lg="6" className="border">
                    <h6>Fecha de finalizacion</h6>
                    <p>{cargo.endDate ? cargo.endDate : "Sin fecha de finalizacion"}</p>
                </Col>
            </Row>
        </Container>
    );
}

const VistaCargo = ({ cargos, showModalArray }) => {
    return (
        <>
            {cargos?.map((cargo, i) => {
                return (
                    <Desplegable
                        showModal={i ? showModalArray[i] : null}
                        Text={mapCargo(cargo)}
                        key={cargo.id}
                        canEdit={false}
                        Toogle={`${cargo.cargo} ${cargo?.workgroup ? `en ${cargo?.workgroup?.name}` : cargo?.mission ? `en ${cargo?.mission?.name}`: cargo?.community ? `en ${cargo?.provincia?.name}` : `en ${cargo?.provincia?.name}`}`}
                    />
                )
            })}
            {cargos?.length === 0 && <p>No hay cargos actualmente</p>}
        </>
    )
};

export default VistaCargo;